import React, { ErrorInfo } from "react";
import LayoutErrorScreen from "../layouts/layoutErrorScreen/layoutErrorScreen";

interface IErrorBoundaryScreenProps {
	children: React.ReactNode;
	route?: string;
}

interface IErrorBoundaryScreenState {
	hasError: boolean;
}

class ErrorBoundaryScreen extends React.Component<IErrorBoundaryScreenProps, IErrorBoundaryScreenState> {
	constructor(props: IErrorBoundaryScreenProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(_error: any) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		// You can also log the error to an error reporting service
		console.error("Uncaught error:", error, errorInfo);
	}
	componentDidUpdate(
		prevProps: Readonly<IErrorBoundaryScreenProps>,
		_prevState: Readonly<IErrorBoundaryScreenState>,
		_snapshot?: any,
	): void {
		const isSameRoute = this.props.route === prevProps.route;
		if (this.state.hasError && !isSameRoute) {
			this.handleReload();
		}
	}

	handleReload = () => {
		// Reload the screen by forcing a re-render.
		this.setState({ hasError: false });
	};

	render() {
		if (this.state.hasError) return <LayoutErrorScreen />;

		return this.props.children;
	}
}

export default ErrorBoundaryScreen;
